import { computed, defineComponent, ref } from '@vue/composition-api';
import { BfButton } from 'components/Butterfly';
import Modal from 'src/components/project/analysis/results/Modal.vue';
import QueryUtils from 'src/utils/query';
const ThemeDeleteModal = defineComponent({
    components: {
        BfButton,
        Modal,
    },
    props: {
        visible: { type: Boolean, required: true },
        selectedQuery: { type: Object, required: true },
        savedQueries: { type: Array, required: true },
        deleteTheme: { type: Function, required: true },
    },
    setup(props) {
        const isLoading = ref(false);
        const deleteConflicts = computed(() => {
            const conflicts = [];
            const id = props.selectedQuery.id.toString();
            props.savedQueries.forEach((query) => {
                const rows = QueryUtils.botanicToQueryRows(query.query_value);
                rows.forEach((row) => {
                    if (row.type === 'query' && row.values?.includes(id)) {
                        conflicts.push(query);
                    }
                });
            });
            return conflicts;
        });
        const doDelete = async () => {
            isLoading.value = true;
            await props.deleteTheme(props.selectedQuery, deleteConflicts.value);
            isLoading.value = false;
        };
        return {
            isLoading,
            deleteConflicts,
            doDelete,
        };
    },
});
export default ThemeDeleteModal;
